export function in_array(val, arr) {
    const res = arr.findIndex(function (s) {
        return s == val;
    });

    return res >= 0 ? true : false;
}

export function getSuffix(str, symbol = '.', returnEmpty = true) {
    const lastIndex = str.lastIndexOf(symbol);

    if (lastIndex === -1) {
        if (returnEmpty) {
            return '';
        } else {
            return str;
        }
    }
    return str.substring(lastIndex + 1);
}

export function removeSuffix(str, symbol = '.', returnEmpty = false) {
    const lastIndex = str.lastIndexOf(symbol);
    if (lastIndex === -1) {
        if (returnEmpty) {
            return '';
        } else {
            return str;
        }
    }
    return str.substring(0, lastIndex);
}

export function array_sum(arr) {
    return arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
}

export function qiniuPrivateShow(url, that, is_open_window = true, extend_params = {}) {
    if (url) {

        if (extend_params['has_token']) {
            if (is_open_window) {
                window.open(url);
            } else {
                that.privateShowCallBack(url, extend_params);
            }
        } else {
            that.$api['getQiNiuDownloadToken']({
                    url: url
                })
                .then((res) => {
                    if (res.data) {
                        if (is_open_window) {
                            window.open(res.data);
                        } else {
                            that.privateShowCallBack(res.data, extend_params);
                        }

                    } else {
                        that.$message({
                            message: '获取预览授权失败',
                            type: 'waring'
                        });
                    }
                })
                .catch((error) => {
                    that.$message({
                        message: '获取预览授权失败',
                        type: 'waring'
                    });
                });
        }


    }
}

export function onDelete(id, that, requestUri, message = '', target = '') {

    if (message == '') {
        message = '您确定要删除吗？';
    } else {
        message = '您确定要删除 [' + message + '] 吗？';
    }
    that.$confirm(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnPressEscape: false,
            closeOnClickModal: false
        })
        .then(() => {
            that.$api[requestUri]({
                    id: id
                })
                .then((res) => {
                    if (res.code == 0) {
                        that.$message({
                            message: '删除成功！',
                            type: 'success'
                        });
                        if (target == '') {
                            that.reload();
                        } else {
                            that.$router.push({
                                path: '/' + target
                            });
                        }
                    }
                })
                .catch((error) => {});
        })
        .catch(() => {});

    return true;
}

// items，暂时不要用。编辑列表也设置后，会跟详情列表也冲突，除非2边显示字段一致
export function onReSize(type, that, start = 0, items = []) {

    setTimeout(function () {
        var colgroup = document.querySelector('.' + type + ' colgroup').children;
        var len = colgroup.length;
        var widthArr = [];
        for (let i = 0; i < len; i++) {
            if (start > 0 && i < start) {
                continue;
            }
            widthArr.push(colgroup[i].width);
        }
        var storageArr = JSON.parse(localStorage.getItem('dataList'));

        var items_len = items.length;

        for (let item in storageArr[type]) {
            if (items_len > 0) {
                if (in_array(item, items)) {
                    storageArr[type][item]['width'] = widthArr.shift();
                }
            } else {
                if (storageArr[type][item].is_show) {
                    storageArr[type][item]['width'] = widthArr.shift();
                }
            }
        }

        localStorage.setItem('dataList', JSON.stringify(storageArr));
        let newObject = Object.values(storageArr[type]);
        var params = {
            object_type: type,
            object: newObject
        }
        that.$api
            .fieldSave(params)
            .then((res) => {
                if (res.code == 0) {}
            })
            .catch((error) => {

            });
    }, 500);

}

export function checkNaturalNumber(rule, value, callback) {
    const num = /^[0-9]*$/
    if (!num.test(value)) {
        callback(new Error("请输入大于等于0的整数"));
    } else {
        callback();
    }
}

export function checkNumber(rule, value, callback) {
    if (rule['required'] && value === '') {
        callback(new Error("请输入数字"));
    }
    const num = /^\-?[0-9]*\.?[0-9]*$/
    if (!num.test(value)) {
        callback(new Error("请输入数字"));
    } else {
        value = String(value);
        if (value[0] == '.' || value[value.length - 1] == '.') {
            callback(new Error("请输入数字"));
        }
        callback();
    }
}

export function onSortChange(val, type, that) {

    if (val.order == 'ascending') {
        that.data_name = val.prop;
        that.sort = 'asc';
    } else if (val.order == 'descending') {
        that.data_name = val.prop;
        that.sort = 'desc';
    } else {
        that.data_name = '';
        that.sort = '';
    }

    if (!that.postList.params) {
        var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
        if (newParamsList) {
            if (newParamsList[type]) {
                newParamsList['data_name'] = that.data_name;
                newParamsList[type]['sort'] = that.sort;
            } else {
                newParamsList[type] = {
                    data_name: that.data_name,
                    sort: that.sort
                };
            }
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
        }
    }

    that.getList(0);
}

// colDataKey目前只支持深度为2 ['key1','key2']
// that[colDataKey] 或 that[colDataKey[0]][colDataKey[1]] 必须是数组，需要push
export function processColumnDataToRow(colData, that, colDataKey = 'colData') {
    var index = 0;
    var tempObj = {};
    for (let key in colData) {
        tempObj[key] = colData[key];
        index++;
        if (index % 2 == 0 && index != 0) {
            if (typeof colDataKey == 'object') {
                that[colDataKey[0]][colDataKey[1]].push(tempObj);
            } else {
                that[colDataKey].push(tempObj);
            }

            tempObj = {};
        }
    }

    if (Object.keys(tempObj).length !== 0) {
        if (typeof colDataKey == 'object') {
            that[colDataKey[0]][colDataKey[1]].push(tempObj);
        } else {
            that[colDataKey].push(tempObj);
        }

    }
}

/**
 * 编辑页字段映射 keys 和 keys_map 字段不要冲突
 * @param {*} colData 字段信息
 * @param {*} that 
 * @param {*} keys {'white':[],'black':[]} white | black 2选1
 * @param {*} key_map {'xxx_label':'xxx','xxxxx':'xxxxx_rid',...}
 */
export function processColDataToEdit(colData, that, keys, key_map = {}) {
    var tempColData = {};
    var mode = keys['black'] ? 'black' : 'white';
    keys = keys[mode];

    // 像 _label 这种需要占用指定位置的，重新循环下
    for (let i in colData) {
        if (key_map[colData[i].prop]) {
            colData[i].prop = key_map[colData[i].prop]
            tempColData[colData[i].prop] = colData[i];
        } else if (mode == 'black') {
            if (!in_array(colData[i].prop, keys)) {
                tempColData[colData[i].prop] = colData[i];
            }
        } else if (mode == 'white') {
            if (in_array(colData[i].prop, keys)) {
                tempColData[colData[i].prop] = colData[i];
            }
        }
    }

    that.colData = Object.values(tempColData);
}

// colDataKey目前只支持深度为2 ['key1','key2']
// that[colDataKey] 或 that[colDataKey[0]][colDataKey[1]] 必须是数组，需要push
export function processColumnDataToRowNew(colData, that, colDataKey = 'colData') {
    var index = 0;
    var tempObj = {};
    for (let key in colData) {
        if (colData[key]['is_show_detail'] == false) {
            continue;
        }

        tempObj[key] = colData[key];
        index++;

        if (index % 2 == 0 && index != 0) {
            if (typeof colDataKey == 'object') {
                that[colDataKey[0]][colDataKey[1]].push(tempObj);
            } else {
                that[colDataKey].push(tempObj);
            }

            tempObj = {};
        }

        // 填充空白占位符
        if (colData[key]['placeholder_detail'] > 0) {
            for (let i = 0; i < colData[key]['placeholder_detail']; i++) {
                tempObj[key + '_' + i] = {};
                index++;

                if (index % 2 == 0 && index != 0) {
                    if (typeof colDataKey == 'object') {
                        that[colDataKey[0]][colDataKey[1]].push(tempObj);
                    } else {
                        that[colDataKey].push(tempObj);
                    }

                    tempObj = {};
                }

            }


        }
    }

    if (Object.keys(tempObj).length !== 0) {
        if (typeof colDataKey == 'object') {
            that[colDataKey[0]][colDataKey[1]].push(tempObj);
        } else {
            that[colDataKey].push(tempObj);
        }

    }
}


// 获取列表 0-非搜索 1-搜索 2-下载
export function onSearch(search_type, that, method) {
    if ([1, 2].indexOf(search_type) != -1) {
        that.queryParams.page = 1;
        that.saveQueryParams();
    }
    if (search_type == 2) {
        that.queryParams.is_export = 1;
        that.down_loading = true;
        that.$api[method + 'DownFile'](that.queryParams)
            .then((res) => {
                that.$message({
                    message: '下载成功!',
                    type: 'success'
                });
                that.down_loading = false;
            })
            .catch((error) => {
                that.down_loading = false;
            });
    } else {
        that.queryParams.is_export = 0;
        that.loading = true;
        that.$api[method](that.queryParams)
            .then((res) => {
                that.tableData = res.data.data;
                that.total = res.data.total;
                //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                if (res.data.current_page > res.data.last_page) {
                    that.queryParams.page = res.data.last_page;
                    that.saveQueryParams();
                    onSearch(search_type, that, method);
                }

                if (typeof that['afterSearch'] === 'function') {
                    that.afterSearch();
                }
                that.loading = false;
            })
            .catch((error) => {
                that.loading = false;
            });
    }
}